import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverChoiceDetails extends Layout {
    sourceDriverChoice: DataSource;
    tableDriverChoiceDetails: Table;
}
